<template>

  <ReportPod />
 
</template>

<script>
import ReportPod from '../components/pratiche/ReportPod.vue'

export default {
  components: {
    ReportPod

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

